import { Resource_AppointmentTaskType } from '@/generated/graphql';

export const availableAppointmentTaskTypes: Resource_AppointmentTaskType[] = [
  Resource_AppointmentTaskType.AppointmentTaskTypeInfo,
  Resource_AppointmentTaskType.AppointmentTaskTypeDocumentUpload,
  Resource_AppointmentTaskType.AppointmentTaskTypeDocumentDownload,
  Resource_AppointmentTaskType.AppointmentTaskTypeForm,
];
